//메인화면 메뉴리스트
import React, { useEffect, useState, } from "react";
import { useHistory } from "react-router-dom";
import { useTheme } from '@mui/material/styles';

//MUI
import { Stack,Divider,Box } from '@mui/material';
import Button from '@mui/material/Button';

//icon
import DevicesIcon from '@mui/icons-material/Devices';                          // Machine
import ImportantDevicesIcon from '@mui/icons-material/ImportantDevices';
import SyncAltIcon from '@mui/icons-material/SyncAlt';                          // Transaction
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';                  // Cash Status
import KeyboardCommandKeyIcon from '@mui/icons-material/KeyboardCommandKey';    // Operating
import SettingsIcon from '@mui/icons-material/Settings';                        // System
import AdjustIcon from '@mui/icons-material/Adjust';                            // Else

// API
import { getAPI } from "../../services/commonService";
import { API } from "../../config";
import { fni18n } from "../../services/commonService";
import AuthenticationService from "../../pages/auth/AuthenticationService";

import { useAtom } from 'jotai';
import menuAtom from "../../utils/reducer/menuAtom"

const MenuList = () => {

  
  const [menuList, setMenuList] = useState([]); //메뉴정보
  
  const isUserId = AuthenticationService.getLoggedInUserID();
  const isBranchCd = AuthenticationService.getLoggedInUserBranchCd();
  
  
  const [ menu, setMenu] = useAtom(menuAtom);

    const history = useHistory();

    const theme = useTheme();

    useEffect(() => {
        try {
            loadMenu()
          } catch (e) {
            console.log(e);
          }
    }, []);

    const loadMenu = async () => {
        try {
          let param = {
            userId:  isUserId,
            branchCd:  isBranchCd,
          };
        await getAPI(API.COMMON.MENU, param)
        .then((res) => {
            setMenuList(res.data.result);
            }
          )
          .catch((err)=>{
            console.log(err)
          });
        } catch (e) {
          console.log(e)
        }
      }

    // onclick event
    const handleClick = (event, obj) => { 
        const {name} = event.target;
        const cmenu = menuList.filter(item => item.m4 === name).map(item => item)
        setMenu(item => ({...item, selected: name, loaded: true, opened: true, marked: cmenu[0].appCd, }))
        // if ( menu.selected !== name ) {
        //   setMenu( item => ({...item, opened: true, marked: cmenu[0].appCd, }) )
        //   history.push(`${obj.m1}`);
        // }
        history.push(`${obj.m1}`);
      };

    return (
    <div style={{marginLeft:25,zIndex:9999}}>
        {/* <Stack direction="row" alignItems="center" sx={{ ml: 10, mt: 1, mb: 1 }} spacing={2}> */}
        <Stack direction="row" alignItems="center">
        <Divider orientation="vertical" variant="middle" flexItem/>
        {
        menuList.filter(obj => obj.m4 == null && obj.m8 !== '0')
        .map((obj) => (
          <>
          <div key={obj.appCd}>
                <Button
                  startIcon={
                    obj.appCd == '0000' ? <DevicesIcon/> : 
                    obj.appCd == "1000" ? <SyncAltIcon/> :
                    obj.appCd == "2000" ? <AttachMoneyIcon/> :
                    obj.appCd == "3000" ? <KeyboardCommandKeyIcon/> : 
                    obj.appCd == "4000" ? <SettingsIcon/> :
                    <AdjustIcon/>
                  }
                  //#8D7C57 gold
                  sx={{
                    color: menu.selected && obj.appCd === menu.selected ? theme.palette.primary.main : theme.link.logo,
                    borderRadius:0,
                    borderBottom: menu.selected && obj.appCd === menu.selected ? `2px solid ${theme.palette.primary.main}` : "none",
                    fontSize:'16px',
                    width:200,
                    height:60,
                    textTransform: "none",
                  }}
                  name={obj.appCd}
                  onClick={ (e) => {handleClick(e, obj)} }
                  >
                    {fni18n(`${obj.m3}`)}
                </Button>
          </div>
          <Divider orientation="vertical" variant="middle" flexItem/>
          </>
        ))}
        </Stack>        
    </div>
    );
}

export default MenuList;
